import { render, staticRenderFns } from "./RightContent.vue?vue&type=template&id=6048df08"
import script from "./RightContent.vue?vue&type=script&lang=js"
export * from "./RightContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6048df08')) {
      api.createRecord('6048df08', component.options)
    } else {
      api.reload('6048df08', component.options)
    }
    module.hot.accept("./RightContent.vue?vue&type=template&id=6048df08", function () {
      api.rerender('6048df08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalHeader/RightContent.vue"
export default component.exports